/* global window, document */

(function (window, document) {
    var wrap = document.querySelector('[data-vg-tools-menu]');
    if (!wrap) return;

    var btn = wrap.querySelector('[data-vg-tools-toggle]');
    var panel = wrap.querySelector('[data-vg-tools-panel]');
    if (!btn || !panel) return;

    function open() {
        panel.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(function () {
            var first = panel.querySelector('a, button, [tabindex]');
            if (first) first.focus();
        });
    }

    function close() {
        panel.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
    }

    function toggle() {
        if (panel.hidden) open();
        else close();
    }

    btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggle();
    });

    document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
    });
})(window, document);

